const RESET = "ARCHIVED_ADVISOR_LISTS/RESET";
const SET_PAGE = "ARCHIVED_ADVISOR_LISTS/SET_PAGE";
const SET_ERROR = "ARCHIVED_ADVISOR_LISTS/SET_ERROR";
const SET_IS_LOADING = "ARCHIVED_ADVISOR_LISTS/SET_IS_LOADING";

const Types = {
  RESET,
  SET_PAGE,
  SET_ERROR,
  SET_IS_LOADING,
};

export default Types;
